var _path, _g, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEykoOutput(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "EykoOutput_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 13,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0v16h-4L3 8l9-8h4z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#EykoOutput_svg__a)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8c0 3.08-2.279 5.5-5 5.5S.5 11.08.5 8s2.279-5.5 5-5.5 5 2.42 5 5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8c0 4.751-3.412 8.5-7.5 8.5S.5 12.751.5 8C.5 3.249 3.912-.5 8-.5s7.5 3.749 7.5 8.5z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 8,
    r: 2.5,
    stroke: "currentColor"
  })));
}

export default SvgEykoOutput;